import React, { Component, useState ,useEffect} from 'react';
import Axios from 'axios';


function Loader(props) {
    const [loading, setsLoading] = useState(false);

    useEffect(() => {
        setsLoading(props.loading)
    }, [props.loading])
    return (
        <div>
            {loading && <div className="overlay">
                            <div className="overlay__inner">
                                <div className="overlay__content"><span className="spinner"></span></div>
                            </div>
                        </div>}
        </div>
    )
}

export default Loader
